import { formatRelativeTime } from "@productlane/lib/src/date"

export type UnsnoozeBadgeContent =
	| { kind: "upcoming"; label: string }
	| { kind: "overdue"; label: string }

export function getUnsnoozeBadgeContent(
	snoozedUntilIso: string,
	now: Date = new Date(),
): UnsnoozeBadgeContent | null {
	if (!snoozedUntilIso) return null
	const parsed = new Date(snoozedUntilIso)
	if (isNaN(parsed.getTime())) return null

	if (parsed.getTime() <= now.getTime()) {
		return { kind: "overdue", label: "Unsnoozing..." }
	}

	const formatted = formatRelativeTime(snoozedUntilIso, false, true).replace(
		/^about /,
		"",
	)
	return { kind: "upcoming", label: `In ${formatted}` }
}
